import CreateIkeaShipmentsModal from "./CreateIkeaShipmentsModal";
export default CreateIkeaShipmentsModal;
